<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  // created() {
  //   const mac = "7C:A7:B0:E7:0B:DA";
  //   console.log(this.$route.query)
  //   this.$store.commit("setMac", mac);
  //   this.$store.dispatch("getStationInfo");
  // },
  data() {
    return {
      timer: null
    };
  }
};
</script>
<style>
html,
body,
#app {
  height: 100%;
}
</style>
